import React, {useState, useEffect} from 'react'
import {useSelector} from "react-redux";
import SeismicPlayer from "@seismic/universal-player";
import {Subject} from 'rxjs';
import { Chart } from "react-google-charts";
import {
    getSentences,
    getParticipants,
    getAimlMeeting,
    getEngagementCenterData,
    getPresentedContent,
    getManifest
} from "../api/client";
import {ContentChip, IconHost, Entity, Tooltip, Toggle} from "@seismic/mantle";
import {SeismicEmployee, Customer} from "./Utils";
import {CenteredSpinner, CenteredSpinner2} from "./CenteredSpinner";

const DocumentRecommendation = ({data}) => {
    
    let document = data.document;
    
    const click = () => {
        window.open(document.url, "_blank");
    }
    
    return <div className="meetingPanel" style={{width: "33%", paddingTop: "8px"}}>

        <div style={{paddingTop: "3px", padding: "8px", border: "1px solid #cfd4da", borderRadius: "4px"}}>
            <Entity
                imgProps={{
                    category: 'content-icons-v2',
                    params: { format: 'email-template' },
                }}
                children={<div>
                    <div style={{paddingBottom: "12px"}}>{data.snippet}</div>
                    <ContentChip
                        imageUrl={document.thumbnail == null || document.thumbnail === "" ? null : "https://bss-gn100.seismic.com/api/image/v1/quake/quake/t" + document.thumbnail.split("/")[6].split("?")[0] + "?requestSize=Origin"}
                        onClick={click}
                        startAdornment={<IconHost category="content-icons-v2" params={{ format: document.format }} size={20} />}
                        title={document.title}
                    />
                    <style>{`
                        [class^='ContentChip__StyledDiv-'] {
                            width: 64px;
                            display: none !important;
                        }
                        [class^='ContentChip__ContentCardOverlay-'] {
                            width: 64px !important;
                            display: none !important;
                        }
                    `}</style>
                </div>}
            />
        </div>

        <div style={{paddingTop: "8px"}}>
            <div style={{height: "100px", overflow: "auto"}}>
                <span dangerouslySetInnerHTML={{__html: cleanText(data.context)}}></span>
            </div>
        </div>
    </div>
}

const cleanText = (data) => {
    
    if(data == null)
        return data;
    
    let toReturn = [];
    
    data.split('\n').map((d, i) => {
        let trimmed = d.trim();
        
        if(trimmed.startsWith("-"))
            trimmed = "&bull;&nbsp;" + trimmed.substring(1).trim();
        
        if (trimmed !== "")
            toReturn.push(trimmed)
    });
    
    return toReturn.join("<br/>");
}

const NlpUserStat = ({user, speakers}) => {
    let speaker = speakers[user.DisplayName];
    if(speaker == null || speaker.wpm == null)
        return null;
    return <tr>
        <td>{user.DisplayName}</td>
        <td>{speaker?.wpm}</td>
        <td>{speaker?.time}</td>
        <td>{speaker?.pause}</td>
        <td>{speaker?.monologue}</td>
    </tr>
}

const distinctBy = (array, keySelector) => {
    const uniqueKeys = new Set();
    return array.filter(item => {
        const key = keySelector(item);
        if (!uniqueKeys.has(key)) {
            uniqueKeys.add(key);
            return true;
        }
        return false;
    });
}

export const MeetingOverviewTab = () => {

    const [participants, setParticipants] = useState();
    const [seismicEventsSubject, setSeismicEventsSubject] = useState(new Subject());

    const [error, setError] = useState(false);
    const [summary, setSummary] = useState();
    const [nextSteps, setNextSteps] = useState();
    const [longSummary, setLongSummary] = useState();

    const [sentenceSummary, setSentenceSummary] = useState();
    const [sentenceTimelineData, setSentenceTimelineData] = useState([]);
    const [documentRecommendations, setDocumentRecommendations] = useState(null);
    
    const [presentedContent, setPresentedContent] = useState(null);
    const [contentTimelineData, setContentTimelineData] = useState([]);
    const [contentPageTimelineData, setContentPageTimelineData] = useState([]);
    const [manifest, setManifest] = useState({});
    const [onlyShowBarcodedImages, setOnlyShowBarcodedImages] = useState(true);

    const [aimlNlp, setAimlNlp] = useState(null);
    const [aimlAmcr, setAimlAmcr] = useState(null);
    const [aimlExtra, setAimlExtra] = useState(null);
    const [aimlSlides, setAimlSlides] = useState(null);
    const [aimlBarcodes, setAimlBarcodes] = useState(null);
    const [aimlThumbnails, setAimlThumbnails] = useState(null);
    const [aimlSummary, setAimlSummary] = useState(null);
    const [aimlGenAiTopics, setAimlGenAiTopics] = useState(null);
    const [aimlImages, setAimlImages] = useState(null);
    
    const selectedMeetingId = useSelector(state => state.users.selectedMeetingId);
    const selectedMeeting = useSelector(state => state.users.selectedMeeting);
    

    const chartColors = [
        "#3498db", "#2ecc71", "#e74c3c", "#f39c12", "#1abc9c",
        "#9b59b6", "#34495e", "#2c3e50", "#16a085", "#d35400",
        "#2980b9", "#27ae60", "#c0392b", "#f39c12", "#8e44ad",
        "#3498db", "#2ecc71", "#e74c3c", "#f39c12", "#1abc9c",
        "#9b59b6", "#34495e", "#2c3e50", "#16a085", "#d35400",
        "#2980b9", "#27ae60", "#c0392b", "#f39c12", "#8e44ad",
        "#3498db", "#2ecc71", "#e74c3c", "#f39c12", "#1abc9c",
        "#9b59b6", "#34495e", "#2c3e50", "#16a085", "#d35400",
        "#2980b9", "#27ae60", "#c0392b", "#f39c12", "#8e44ad",
        "#3498db", "#2ecc71", "#e74c3c", "#f39c12", "#1abc9c",
        "#9b59b6", "#34495e", "#2c3e50", "#16a085", "#d35400",
        "#2980b9", "#27ae60", "#c0392b", "#f39c12", "#8e44ad",
        "#3498db", "#2ecc71", "#e74c3c", "#f39c12", "#1abc9c",
        "#9b59b6", "#34495e", "#2c3e50", "#16a085", "#d35400",
        "#2980b9", "#27ae60", "#c0392b", "#f39c12", "#8e44ad",
        "#3498db", "#2ecc71", "#e74c3c", "#f39c12", "#1abc9c",
        "#9b59b6", "#34495e", "#2c3e50", "#16a085", "#d35400",
        "#2980b9", "#27ae60", "#c0392b", "#f39c12", "#8e44ad"
    ];

    const chartEvents = [
        {
            eventName: "ready",
            callback: ({ chartWrapper, google }) => {
                const chart = chartWrapper.getChart();
                google.visualization.events.removeAllListeners(chart);
                console.log("Chart is ready");
                google.visualization.events.addListener(chart, "select", e => {
                    const selection = chart.getSelection();
                    const row = selection[0].row;
                    const dataTable = chartWrapper.getDataTable();
                    const data = dataTable.getValue(row, 5);
                    setPosition(data);
                });
            }
        }
    ];
    
    const loadParticipants = async () => {
        let participants = await getParticipants(selectedMeetingId);
        setParticipants(participants);
    }
    
    const columns = [
        { type: "string", id: "Group" },
        { type: "string", id: "Name" },
        { type: "string", role: 'tooltip' },
        { type: "datetime", id: "Start" },
        { type: "datetime", id: "End" },
        { type: "string", role: "data" }
    ];
    
    const loadSentenceSummary = async () => {
        let summary = await getSentences(selectedMeetingId);
        let rows = summary.sentences.filter(a=>a.sentenceStartedAt !== null)
            .map(a=>['Speaker', a.participantName?.toUpperCase() ?? "N/A", `<div style='padding: 8px; width:400px'><h5 style='padding-bottom: 8px'>${(a.participantName?.toUpperCase() ?? 'N/A')}</h5><div style='border-top: 1px solid #cfd4da'/><div style='padding-top: 8px'>${a.sentenceText}</div></div>`, new Date(a.sentenceStartedAt), new Date(a.sentenceEndedAt), a.sentenceStartMilliseconds / 1000]);
        setSentenceSummary(summary);
        setSentenceTimelineData(rows);
    }
        
    const loadPresentedContent = async () => {
        let presentedContent = await getPresentedContent(selectedMeetingId);
        setPresentedContent(presentedContent);
        let rows = presentedContent.contents.map(a=>['Content', a.contentName?.toUpperCase() ?? "N/A", `<div style='padding: 8px; width:400px'><h5 style='padding-bottom: 8px'>${(a.contentName?.toUpperCase() ?? 'N/A')}</h5><div style='border-top: 1px solid #cfd4da'/><div style='padding-top: 8px'>Presented by: ${a.contentPresentedByUserName}<br />${a.contentStartMilliseconds}-${a.contentEndMilliseconds}</div></div>`, new Date(a.contentStartedAt), new Date(a.contentEndedAt), a.contentStartMilliseconds / 1000]);
        setContentTimelineData(rows);

        let arr = [];
        for(let i = 0; i < presentedContent.contents.length; i++) {
            let content = presentedContent.contents[i];
            for (let j = 0; j < content.pages.length; j++) {
                let page = content.pages[j];
                arr.push({title: content.contentName + " Page " +  page.meetingContentPagePresentationPageIndex, page: page});
            }
        }
        
        let pageRows = arr.map(a=>['Pages', a.title?.toUpperCase() ?? "N/A", `<div style='padding: 8px; width:400px'><h5 style='padding-bottom: 8px'>${(a.title?.toUpperCase() ?? 'N/A')}</h5><div style='border-top: 1px solid #cfd4da'/><div style='padding-top: 8px'>Presented for: ${a.page.meetingContentPagePresentationDurationSeconds} seconds<br/>${a.page.pageStartMilliseconds}-${a.page.pageEndMilliseconds}</div></div>`, new Date(a.page.meetingContentPagePresentationStartedAt), new Date(a.page.meetingContentPagePresentationEndedAt), a.page.pageStartMilliseconds / 1000]);
        setContentPageTimelineData(pageRows);
    }

    const loadManifest = async () => {
        let data = await getManifest(selectedMeetingId);
        setManifest(data);
    }
    
    const [engagementCenterUrl, setEngagementCenterUrl] = useState(null);
    
    const loadEngagementCenterData = async () => {
        if(selectedMeeting == null)
            return;
        let data = await getEngagementCenterData({
            "limit":20,
            "offset":0,
            "keyword":selectedMeeting.title,
            "sortKey":"lastsent",
            "sortDirection":"desc",
            "isArchived":false,
            "ownerIds":[]
        })
        
        let foundItem = data.items.find(a=>a?.externalMeetingInfo?.externalMeetingId === selectedMeeting.externalMeetingId);
        if(foundItem == null)
            return;
        
        setEngagementCenterUrl("https://quake.seismic.com/app#/engagementcenter/engagement/meeting/" + foundItem.engagementId);
    }
    
    const loadAimlMeeting = async () => {
        let data = await getAimlMeeting(selectedMeetingId);
        setAimlNlp(data?.meta_data?.nlp);
        setAimlAmcr(data?.meta_data?.amcr);
        setAimlExtra(data?.meta_data?.extra);
        setAimlSlides(data?.meta_data?.slides);
        setAimlBarcodes(data?.meta_data?.barcodes);
        setAimlThumbnails(data?.meta_data?.thumbnails);
        setAimlSummary(data?.meta_data["aiml-summary"]);
        setAimlGenAiTopics(data?.meta_data["gen-ai-topics"]);
        setAimlImages(data?.meta_data?.images);
        
    }
    
    useEffect(() => {
        setError(false);
        setSummary(null);
        setNextSteps(null);
        setLongSummary(null)
        setAimlNlp(null);
        setAimlExtra(null);
        setAimlAmcr(null);
        setAimlSlides(null);
        setAimlBarcodes(null);
        setAimlImages(null);
        setAimlThumbnails(null);
        setAimlSummary(null);
        setAimlGenAiTopics(null);
        setManifest({});
        setParticipants(null);
        setDocumentRecommendations(null);
        setPresentedContent(null);
        setContentTimelineData([])
        setContentPageTimelineData([])
        setEngagementCenterUrl(null);
        if(selectedMeetingId != null && selectedMeetingId !== "") {
            loadSentenceSummary();
            loadParticipants();
            loadPresentedContent();
            loadManifest();
            loadAimlMeeting();
            loadEngagementCenterData();
        }
    }, [selectedMeetingId]);

    const setPosition = (newPosition) => {
        seismicEventsSubject?.next(
            {
                type: "Media",
                event: {
                    action: "Seek",
                    newPosition: newPosition,
                    pause: false
                },
                version: "2.0",
                timestamp: new Date().toISOString()
            }
        );
    }
    
    if(selectedMeetingId == null)
        return <div>No meeting selected.</div>
    
    if(participants == null || sentenceSummary == null)
        return <CenteredSpinner height="80vh" message="Loading..." />
    
    let filteredImages = (aimlImages ?? []).filter(a=>!onlyShowBarcodedImages || (onlyShowBarcodedImages && a.barcode != null));
    
    return <div style={{width: "100%"}}>
        {engagementCenterUrl && <div style={{backgroundColor: "orange", position: "relative", width: "100%"}}>
            <div style={{position: "absolute", right: 0, top: 4}}>
                <a href={engagementCenterUrl} target="_blank">View in engagement center</a>
            </div>
        </div>}
        
        {/*<ShowThumbnail originalThumbnailUrl={thumbnailUrl} showModal={showThumbnailModal} setShowModal={setShowThumbnailModal} />*/}
        {aimlSummary && <div style={{display: "flex", gap: "8px"}}>
            <div style={{flex: "1 1 50%"}}>
                <div style={{display: "flex", flexDirection: "column", height: "100%"}}>
                    <div className="header">Summary</div>
                    <div className="meetingPanel" style={{flex: 1}}>
                        {aimlSummary.summary.map(a=><li>{a}</li>)}
                    </div>
                </div>
            </div>
            <div style={{flex: "1 1 50%"}}>
                <div style={{display: "flex", flexDirection: "column", height: "100%"}}>
                    <div className="header">Next Steps</div>
                    <div className="meetingPanel" style={{flex: 1}}>
                        {aimlSummary.nextSteps.map(a=><li>{a.actionText}</li>)}
                    </div>
                </div>
            </div>
        </div>}

        <div className="header">Participants</div>
        <div className="meetingPanel">
            {participants.map(x=><span style={{paddingRight: "12px"}} key={x.name}>{x.isCustomer ? <Customer/> : <SeismicEmployee />}&nbsp;<span style={{fontWeight: x.type !== "Participant" ? "bold" : null}}>{x.name}</span></span>)}
        </div>
        
        <div style={{display: "flex", zIndex: 1000, gap: 8}}>
            {aimlImages && <div style={{flex: "1 0 34%"}}>
                <div style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
                    <div className="header">Thumbnails</div>
                    <div style={{display: "flex", alignItems: "center", gap: "8px"}}>Only show barcoded images <Toggle checked={onlyShowBarcodedImages} onChange={e=>setOnlyShowBarcodedImages(e.target.checked)} /></div>
                </div>
                <div className="meetingPanel">
                    <table style={{height: "680px", overflowY: "scroll", display: "block", width: "100%"}}>
                        <thead>
                        <tr>
                            <th>Image</th>
                            <th>Frame Name</th>
                            <th>Barcode</th>
                            <th>Start</th>
                        </tr>
                        </thead>
                        <tbody>
                        {filteredImages.map((a, i)=><tr key={i}>
                            <td>
                                <img alt={a.blobId} loading="lazy" width={192} height={108} src={a.thumbnailUrl} />
                            </td>
                            <td>
                                {a.frameName}
                            </td>
                            <td>{a.barcode ? a.barcode : "no"}</td>
                            <td><a style={{cursor: "pointer"}} onMouseOver={()=>setPosition(a.relativeStart/1000)} onClick={()=>setPosition(a.relativeStart/1000)}>{a.rangeStart}</a></td>
                        </tr>)}
                        {filteredImages.length === 0 && <tr><td colSpan="3">No barcoded images found</td></tr>}
                        </tbody>
                    </table>
                </div>
            </div>}
            <div style={{flex: "1 0 66%"}}>
                <div className="header">Meeting Recording</div>
                <div>
                    <SeismicPlayer
                        seismicEvents$={seismicEventsSubject?.asObservable()}
                        config={manifest}
                        lang="en-US"
                        autoplay={false}/>
                </div>
            </div>
        </div>
        
        <div className="header">Timeline</div>
        <div className="meetingPanel" style={{maxHeight: (contentPageTimelineData.length === 0 ? "60px" : "150px")}}>
            <Chart
                className="timeline"
                chartType="Timeline"
                chartEvents={chartEvents}
                data={[columns, ...sentenceTimelineData, ...contentTimelineData, ...contentPageTimelineData]}
                height={"305px"}
                options={{
                    tooltip: {
                        isHtml: true
                    },
                    timeline: {
                        showBarLabels: false,
                        showRowLabels: true
                    },
                    colors: chartColors
                }}
            />
        </div>

        {aimlAmcr && <div>
            <div className="header">Recommendations</div>
            <div className="meetingPanel">
                <table>
                    <thead>
                    <tr>
                        <th>Name</th>
                        <th>Keywords</th>
                    </tr>
                    </thead>
                    <tbody>
                    {aimlAmcr?.recommendations.map((a, i)=><tr key={i}>
                        <td><a target="_blank" href={`https://quake.seismic.com/app#/contentmanager/detail/${a.teamsiteId}/${a.contentId}/info/LIST/title?versionId=${a.contentVersionId}&structureId=undefined`}>{a.title ?? a.name}</a></td>
                        <td>{a.keywordsMatched.map((x, i)=><span>{i > 0 ? " | " : ""}{x.trim().replaceAll('APOSTROPHETOKEN', '\'')}</span>)}</td>
                    </tr>)}
                    {aimlAmcr.recommendations.length === 0 && <tr><td colSpan="2">No recommendations found</td></tr>}
                    </tbody>
                </table>

            </div>
        </div>}

        {aimlGenAiTopics && <div>
            <div className="header">Topics</div>
            <div className="meetingPanel">
                <table>
                    <thead>
                    <tr>
                        <th>Text</th>
                        <th>Topic</th>
                    </tr>
                    </thead>
                    <tbody>
                    {aimlGenAiTopics.objections?.map((a, i)=><tr key={i}>
                        <td>{a.text.replaceAll('APOSTROPHETOKEN', '\'')}</td>
                        <td>Objection</td>
                    </tr>)}
                    {aimlGenAiTopics.commercialTopics?.map((a, i)=><tr key={i}>
                        <td>{a.text.replaceAll('APOSTROPHETOKEN', '\'')}</td>
                        <td>Commercial</td>
                    </tr>)}
                    {aimlGenAiTopics.discoveryQuestions?.map((a, i)=><tr key={i}>
                        <td>{a.text.replaceAll('APOSTROPHETOKEN', '\'')}</td>
                        <td>Discovery</td>
                    </tr>)}
                    </tbody>
                </table>
            </div>
        </div>}
        
        {aimlNlp && <div>
            <div className="header">Speaker Info</div>
            <div className="meetingPanel">
                WPM: {aimlNlp?.stats?.wpm} <br/>
                Total Duration: {aimlNlp?.stats?.total_duration} <br/>
                Filler Words: {(aimlNlp?.stats?.filler_words_perc * 100).toLocaleString()}% <br/>
                Interjections: {(aimlNlp?.stats?.interjections_perc * 100).toLocaleString()}% <br/>

                <table>
                <thead>
                    <tr>
                        <th>DisplayName</th>
                        <th>WPM</th>
                        <th>Time</th>
                        <th>Pause</th>
                        <th>Monologue</th>
                    </tr>
                </thead>
                <tbody>
                {aimlNlp?.users?.map(a=>
                    <NlpUserStat speakers={aimlNlp?.stats?.speakers} user={a} />
                    )}
                </tbody>
                </table>
                
            </div>
            </div>}
        
        
        {/*aimlSlides && <div>
        <div className="header">Slides</div>
            <div className="meetingPanel">
            <table>
                <thead>
                <tr>
                    <th>Name</th>
                    <th>Pred</th>
                </tr>
                </thead>
                <tbody>
                    {aimlSlides?.map((a, i)=><tr key={i}>
                        <td>{a.name}</td>
                        <td>{a.pred}</td>
                    </tr>)}
                </tbody>
            </table>
            </div>
        </div>*/}
        
        {false && aimlThumbnails && <div>
            <div className="header">Thumbnails</div>
            <div className="meetingPanel">
            <table>
                <thead>
                <tr>
                    <th>Blob</th>
                    <th>VideoBlob</th>
                    <th>Barcode</th>
                    <th>FrameName</th>
                    <th>Range</th>
                </tr>
                </thead>
                <tbody>
                {aimlThumbnails?.map((a, i)=><tr key={i}>
                    <td>
                        <Tooltip size="lg" position="right" content={<img loading="lazy" src={a.thumbnailUrl} />}>
                            <span>
                                <img loading="lazy" width={192} height={108} src={a.thumbnailUrl} />
                            </span>
                        </Tooltip>
                        {a.blobId}
                     </td>
                    <td><a href={a.videoThumbnailUrl}>{a.videoBlobId}</a></td>
                    <td>{a.barcode}</td>
                    <td>{a.frameName}</td>
                    <td>{a.range}</td>
                </tr>)}
                </tbody>
            </table>
            </div>
        </div>}
    </div>
};